export default "__VITE_ASSET__Dj8yDc7D__"